import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {MoveIoUploadState} from '@local/redux/state/pages/moveIoUpload';

// 初期ステートをこういう感じにするとページ増えたときのredux層の情報量が増えるけど
// 数百万件とか裁こうとしてる中でこういうのが多少あってもそもそも変わらんし
// ページ遷移時の遅延がない（最初から初期状態は持ってる）ほうがいいし
// stateなし、初期ロード前、ロード後の3段階管理する複雑さによる開発への影響と
// その結果の品質への影響のほうが大きいので、こうする。
const initialState: MoveIoUploadState = {
  mainTab: 'import',
  importOperation: 'register_move_in',
  jobs: [],
  uploadState: 'ready',
};
const moveIoUploadSlice = createSlice({
  name: 'moveIoUpload',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Partial<MoveIoUploadState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clear: () => initialState,
  },
});
export const moveIoUploadReducer = moveIoUploadSlice.reducer;
export const moveIoUploadActions = moveIoUploadSlice.actions;
